export const fmt = (n) => (n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
export const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
